var _path, _path2, _path3, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 17,
    viewBox: "0 0 18 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75073 11.8484C8.38848 11.8484 8.09448 11.5544 8.09448 11.1921V0.65625C8.09448 0.294 8.38848 0 8.75073 0C9.11298 0 9.40698 0.294 9.40698 0.65625V11.1921C9.40698 11.5544 9.11298 11.8484 8.75073 11.8484",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.75066 11.8479C8.57654 11.8479 8.40854 11.7788 8.28604 11.6545L5.73454 9.09341C5.47904 8.83616 5.47991 8.42054 5.73629 8.16504C5.99354 7.90954 6.40829 7.90954 6.66379 8.16679L8.75066 10.2624L10.8375 8.16679C11.093 7.90954 11.5078 7.90954 11.765 8.16504C12.0214 8.42054 12.0223 8.83616 11.7668 9.09341L9.21529 11.6545C9.09279 11.7788 8.92479 11.8479 8.75066 11.8479",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1659_14820",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 18,
    height: 13
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 4.14062H17.4998V16.1666H0V4.14062Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1659_14820)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6281 16.1666H3.88062C1.74125 16.1666 0 14.4263 0 12.286V8.01163C0 5.87662 1.73688 4.14062 3.87275 4.14062H4.69613C5.05838 4.14062 5.35238 4.43463 5.35238 4.79688C5.35238 5.15913 5.05838 5.45313 4.69613 5.45313H3.87275C2.4605 5.45313 1.3125 6.60025 1.3125 8.01163V12.286C1.3125 13.7026 2.464 14.8541 3.88062 14.8541H13.6281C15.0386 14.8541 16.1875 13.7053 16.1875 12.2948V8.02125C16.1875 6.60463 15.0351 5.45313 13.6202 5.45313H12.8047C12.4425 5.45313 12.1485 5.15913 12.1485 4.79688C12.1485 4.43463 12.4425 4.14062 12.8047 4.14062H13.6202C15.7596 4.14062 17.5 5.88188 17.5 8.02125V12.2948C17.5 14.4298 15.7622 16.1666 13.6281 16.1666",
    fill: "white"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.8122837aee8af0ae8d74367d324e42ac.svg";
export { ForwardRef as ReactComponent };